<template>
  <div>
    <div
      class="modal fade"
      :id="id"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <template
        v-if="
          isShowScantron && showQuestionPanel && qaStatus && !isFilterPanelOpen
        "
      >
        <button
          type="button"
          class="btn btn-dark btn-sm modal-navigate_prev d-flex"
          @keyup.left="goToPrev"
          @click="goToPrev"
        >
          <i class="pz-icon icon-first-page"></i>
          <span class="d-none d-md-inline">上一题</span>
        </button>
        <button
          type="button"
          class="btn btn-dark btn-sm modal-navigate_next d-flex"
          @keyup.right="goToNext"
          @click="goToNext"
        >
          <span class="d-none d-md-inline">下一题</span>
          <i class="pz-icon icon-last-page"></i>
        </button>
      </template>
      <div
        :class="{
          _v2:
            exerciseType != '13' &&
            exerciseType != '11' &&
            (showBeforePanel || showAfterPanel) &&
            !(exerciseType == '12' && showBeforePanel),
          'modal-fullscreen': isFullscreen,
        }"
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-custom"
        role="document"
      >
        <Loading
          v-if="showSpinnerPanel"
          :onClose="close"
          :title="title"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
          :isFixedOnTop="true"
        />

        <FirstFilter
          :exerciseType="exerciseType"
          :list="FirstFilterList"
          v-if="showFirstFilterPanel && !showCollectionWronglistFilterPanel"
          :setIsShowFirstFilterPanelAndContent="
            setIsShowFirstFilterPanelAndContent
          "
          :onClose="close"
          :title="title"
          :onGetQuestions="onGetQuestions"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
        />

        <CollectionWronglistFilter
          :exerciseType="exerciseType"
          :bookTreeList="FirstFilterList"
          :typeQuestionList4mycollection="typeQuestionList4mycollection"
          :mywrongCountList="mywrongCountList"
          v-if="showFirstFilterPanel && showCollectionWronglistFilterPanel"
          :isShowFirstFilterPanelContent="isShowFirstFilterPanelContent"
          :setIsShowFirstFilterPanelContent="setIsShowFirstFilterPanelContent"
          :isShowQuestionPanel="isShowQuestionPanel"
          :onClose="close"
          :title="title"
          :onGetQuestions="onGetQuestions"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
        />

        <Before
          v-if="showBeforePanel"
          :exerciseType="exerciseType"
          :title="title"
          :onClose="close"
          :onGetQuestions="onGetQuestions"
          :BeforeData="BeforeData"
          :onStartCountingDown="startCountingDown"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
          :isInReview="isInReview"
          :setIsInReview="setIsInReview"
        />
        <After
          v-if="showAfterPanel"
          :exerciseType="exerciseType"
          :title="title"
          :onClose="close"
          :AfterData="AfterData"
          :onBackToPaper="onBackToPaper"
          :onRetry="onRetry"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
          :isInReview="isInReview"
          :setIsInReview="setIsInReview"
        />

        <NoData
          :onClose="close"
          :title="title"
          :exerciseType="exerciseType"
          v-if="showNoDataPanel"
          :isFullscreen="isFullscreen"
          :onResizeModal="resizeModal"
        />
        <div
          :class="isShowFirstFilterPanelContent ? 'd-none' : 'modal-content'"
          v-if="showQuestionPanel"
        >
          <!-- <PzFilter
            v-if="exerciseType === 8"
            :PzFilterData="PzFilterData"
            :onGetQuestions="onGetQuestions"
          />-->
          <div
            class="modal-header justify-content-between align-items-center bg-light px-2 py-1"
          >
            <div class="flex-grow-1 w-0 text-truncate">
              <ul
                class="list-inline mb-0 d-flex align-items-center text-truncate"
              >
                <li class="list-inline-item pr-0 pr-md-2 border-right">
                  <button
                    type="button"
                    class="btn btn-light text-secondary d-flex"
                    @click.prevent="checkWhenClose()"
                  >
                    <i class="pz-icon icon-cancel mr-1"></i>
                    <span class="d-none d-md-inline-block">
                      {{ isTakingExam ? '' : '结束答题' }}
                    </span>
                  </button>
                </li>
                <li class="list-inline-item ml-2 ml-md-3 text-truncate">
                  <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
                </li>
              </ul>
            </div>

            <ul class="list-inline mb-0 d-flex align-items-center">
              <li
                class="list-inline-item mx-0 mx-lg-2"
                v-if="
                  (exerciseType == 8 ||
                    exerciseType == 2 ||
                    exerciseType == 3) &&
                  isShowFilter
                "
              >
                <button
                  @click="openFilter"
                  type="button"
                  class="btn btn-light text-secondary collapsed d-flex flex-column"
                >
                  <i class="pz-icon icon-filter"></i>
                  <small class="d-none d-md-inline-block">筛选</small>
                </button>
              </li>

              <li class="list-inline-item mx-0 mx-lg-2">
                <div class="dropdown">
                  <a
                    class="btn btn-light text-secondary d-flex flex-column align-items-center"
                    href="javascript:undefined;"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="22px"
                      viewBox="0 -960 960 960"
                      width="22px"
                      fill="#ADB5BD"
                    >
                      <path
                        d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z"
                      />
                    </svg>

                    <small class="d-none d-md-inline-block">语言</small>
                  </a>

                  <div
                    class="dropdown-menu dropdown-menu-right shadow-lg w-200 p-0"
                  >
                    <div class="list-group rounded-0">
                      <a
                        href="javascript:undefined;"
                        class="list-group-item list-group-item-action"
                        :class="!questionLanguage ? 'active' : ''"
                        :aria-current="!questionLanguage ? true : false"
                        @click.prevent="setQuestionLanguage('')"
                      >
                        English
                      </a>
                      <a
                        href="javascript:undefined;"
                        class="list-group-item list-group-item-action"
                        :class="'zh' === questionLanguage ? 'active' : ''"
                        :aria-current="'zh' === questionLanguage ? true : false"
                        @click.prevent="setQuestionLanguage('zh')"
                      >
                        中文
                      </a>
                    </div>
                  </div>
                </div>
              </li>

              <li class="list-inline-item mx-0 mx-lg-2">
                <div class="dropdown">
                  <a
                    class="btn btn-light text-secondary d-flex flex-column align-items-center"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.3477 13.9736L19.0684 12.8799C19.1289 12.5088 19.1602 12.1299 19.1602 11.751C19.1602 11.3721 19.1289 10.9932 19.0684 10.6221L20.3477 9.52832C20.4442 9.44571 20.5132 9.33569 20.5457 9.21289C20.5781 9.09008 20.5724 8.9603 20.5293 8.84082L20.5117 8.79004C20.1595 7.80571 19.6322 6.89323 18.9551 6.09668L18.9199 6.05566C18.8378 5.95909 18.7283 5.88966 18.6059 5.85654C18.4836 5.82342 18.354 5.82815 18.2344 5.87012L16.6465 6.43457C16.0605 5.9541 15.4063 5.57519 14.6992 5.30957L14.3926 3.64941C14.3694 3.5245 14.3088 3.40958 14.2188 3.31992C14.1288 3.23026 14.0137 3.17011 13.8887 3.14746L13.8359 3.1377C12.8184 2.9541 11.748 2.9541 10.7305 3.1377L10.6777 3.14746C10.5527 3.17011 10.4376 3.23026 10.3476 3.31992C10.2576 3.40958 10.197 3.5245 10.1738 3.64941L9.86524 5.31738C9.16385 5.58306 8.51068 5.96177 7.93164 6.43848L6.33203 5.87012C6.21244 5.82782 6.0828 5.82291 5.96035 5.85605C5.83789 5.8892 5.72843 5.95882 5.64649 6.05566L5.61133 6.09668C4.93506 6.8938 4.40777 7.80613 4.05469 8.79004L4.03711 8.84082C3.94922 9.08496 4.02149 9.3584 4.21875 9.52832L5.51368 10.6338C5.45313 11.001 5.42383 11.376 5.42383 11.749C5.42383 12.124 5.45313 12.499 5.51368 12.8643L4.21875 13.9697C4.12226 14.0523 4.0532 14.1624 4.02075 14.2852C3.98831 14.408 3.99401 14.5377 4.03711 14.6572L4.05469 14.708C4.40821 15.6924 4.93164 16.6006 5.61133 17.4014L5.64649 17.4424C5.72863 17.539 5.8381 17.6084 5.96048 17.6415C6.08286 17.6746 6.2124 17.6699 6.33203 17.6279L7.93164 17.0596C8.51368 17.5381 9.16407 17.917 9.86524 18.1807L10.1738 19.8486C10.197 19.9735 10.2576 20.0885 10.3476 20.1781C10.4376 20.2678 10.5527 20.3279 10.6777 20.3506L10.7305 20.3603C11.7574 20.5449 12.809 20.5449 13.8359 20.3603L13.8887 20.3506C14.0137 20.3279 14.1288 20.2678 14.2188 20.1781C14.3088 20.0885 14.3694 19.9735 14.3926 19.8486L14.6992 18.1885C15.406 17.9235 16.064 17.5434 16.6465 17.0635L18.2344 17.6279C18.354 17.6702 18.4836 17.6751 18.6061 17.642C18.7285 17.6088 18.838 17.5392 18.9199 17.4424L18.9551 17.4014C19.6348 16.5986 20.1582 15.6924 20.5117 14.708L20.5293 14.6572C20.6172 14.417 20.5449 14.1436 20.3477 13.9736V13.9736ZM17.6816 10.8525C17.7305 11.1475 17.7559 11.4502 17.7559 11.7529C17.7559 12.0557 17.7305 12.3584 17.6816 12.6533L17.5527 13.4365L19.0117 14.6846C18.7905 15.1941 18.5114 15.6765 18.1797 16.1221L16.3672 15.4795L15.7539 15.9834C15.2871 16.3662 14.7676 16.667 14.2051 16.8779L13.4609 17.1572L13.1113 19.0518C12.5597 19.1143 12.0028 19.1143 11.4512 19.0518L11.1016 17.1533L10.3633 16.8701C9.80664 16.6592 9.28907 16.3584 8.82618 15.9775L8.21289 15.4717L6.38868 16.1201C6.05664 15.6728 5.7793 15.1904 5.55664 14.6826L7.03125 13.4229L6.9043 12.6416C6.85743 12.3506 6.83204 12.0498 6.83204 11.7529C6.83204 11.4541 6.85547 11.1553 6.9043 10.8643L7.03125 10.083L5.55664 8.82324C5.77735 8.31348 6.05664 7.83301 6.38868 7.38574L8.21289 8.03418L8.82618 7.52832C9.28907 7.14746 9.80664 6.84668 10.3633 6.63574L11.1035 6.35644L11.4531 4.45801C12.002 4.39551 12.5625 4.39551 13.1133 4.45801L13.4629 6.35254L14.207 6.63184C14.7676 6.84277 15.2891 7.14355 15.7559 7.52637L16.3691 8.03027L18.1816 7.38769C18.5137 7.83496 18.791 8.31738 19.0137 8.82519L17.5547 10.0732L17.6816 10.8525ZM12.2852 8.12012C10.3867 8.12012 8.84766 9.65918 8.84766 11.5576C8.84766 13.4561 10.3867 14.9951 12.2852 14.9951C14.1836 14.9951 15.7227 13.4561 15.7227 11.5576C15.7227 9.65918 14.1836 8.12012 12.2852 8.12012ZM13.832 13.1045C13.6291 13.308 13.388 13.4693 13.1226 13.5793C12.8571 13.6892 12.5725 13.7456 12.2852 13.7451C11.7012 13.7451 11.1523 13.5166 10.7383 13.1045C10.5348 12.9016 10.3735 12.6605 10.2635 12.395C10.1536 12.1295 10.0972 11.845 10.0977 11.5576C10.0977 10.9736 10.3262 10.4248 10.7383 10.0107C11.1523 9.59668 11.7012 9.37012 12.2852 9.37012C12.8691 9.37012 13.418 9.59668 13.832 10.0107C14.0355 10.2136 14.1969 10.4547 14.3068 10.7202C14.4167 10.9857 14.4731 11.2703 14.4727 11.5576C14.4727 12.1416 14.2441 12.6904 13.832 13.1045Z"
                        fill="#ADB5BD"
                      />
                    </svg>

                    <!-- <i class="pz-icon icon-modal-setting"></i> -->

                    <small class="d-none d-md-inline-block">设置</small>
                  </a>
                  <form
                    class="dropdown-menu dropdown-menu-right p-4 shadow-lg w-200"
                  >
                    <div class="pb-3">
                      <p class="mb-2">更改文字大小</p>
                      <div
                        class="btn-group btn-group-toggle btn-group-font"
                        data-toggle="buttons"
                      >
                        <label
                          class="btn btn-light text-secondary btn-group-font-sm"
                          :class="{ active: questionFontSize === 1 }"
                          @click="setQuestionFontSize(1)"
                        >
                          <input
                            type="radio"
                            name="options"
                            id="option1"
                            autocomplete="off"
                            :value="1"
                            v-model="questionFontSize"
                          />
                          小
                        </label>
                        <label
                          class="btn btn-light text-secondary btn-group-font-default"
                          :class="{ active: questionFontSize === 2 }"
                          @click="setQuestionFontSize(2)"
                        >
                          <input
                            type="radio"
                            name="options"
                            :value="2"
                            v-model="questionFontSize"
                            id="option2"
                            autocomplete="off"
                          />
                          中
                        </label>
                        <label
                          class="btn btn-light text-secondary btn-group-font-lg"
                          :class="{ active: questionFontSize === 3 }"
                          @click="setQuestionFontSize(3)"
                        >
                          <input
                            :value="3"
                            v-model="questionFontSize"
                            type="radio"
                            name="options"
                            id="option3"
                            autocomplete="off"
                          />
                          大
                        </label>
                      </div>
                    </div>
                    <div v-if="!isTakingExam" class="dropdown-divider"></div>
                    <div v-if="!isTakingExam" class="pt-2">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="turnOnVoice"
                          id="customSwitch2"
                        />
                        <label class="custom-control-label" for="customSwitch2"
                          >答题音效</label
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </li>
              <li class="list-inline-item mx-0 mx-lg-2">
                <button
                  type="button"
                  class="btn btn-light text-secondary d-flex flex-column"
                  @click="resizeModal()"
                >
                  <i
                    class="pz-icon"
                    :class="`${
                      isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'
                    }`"
                  ></i>
                  <small class="d-none d-md-inline-block">{{
                    isFullscreen ? '恢复' : '全屏'
                  }}</small>
                </button>
              </li>
            </ul>
          </div>

          <!-- 小题 -->
          <Small
            v-if="Question.qType !== 'xl'"
            :QuestionList="QuestionList"
            :isTakingExam="isTakingExam"
            :Question="Question"
            :notable="notable"
            :onNoteSaved="onNoteSaved"
            :markable="markable"
            :onMark="onMark"
            :isShowScantron="isShowScantron"
            :p_isQuestionReported="isQuestionReported"
            :onAnswer="answer"
            :onGoToNext="goToNext"
            :onClose="checkWhenClose"
            :Position="Position"
            :isShowStepper="isShowStepper"
            :onSetQuestion="onSetQuestion"
            :surplusTime="SurplusTime"
            :onGetAfterData="onGetAfterData"
            :exerciseType="exerciseType"
            :id="id"
            :isReadOnly="isReadOnly"
            :questionFontSize="questionFontSize"
            :onRemoveWrongList="onRemoveWrongList"
            :isInReview="isInReview"
            :setIsInReview="setIsInReview"
            @save-question-rangy-mark="saveQuestionRangyMark"
          >
            <template #note="{ isShowNote }">
              <note
                :Question="Question"
                :onNoteSaved="onNoteSaved"
                :typeOfEditor="'EXERCISE_NOTE'"
                v-if="ms_isDebug && notable && isOpened && isShowNote"
              />
            </template>
          </Small>
          <!-- end of 小题 -->

          <!-- 大题 -->
          <Big
            v-if="Question.qType === 'xl'"
            :QuestionList="QuestionList"
            :isTakingExam="isTakingExam"
            :Question="Question"
            :notable="notable"
            :markable="markable"
            :onMark="onMark"
            :isShowScantron="isShowScantron"
            :p_isQuestionReported="isQuestionReported"
            :onAnswer="answer"
            :onGoToNext="goToNext"
            :onClose="checkWhenClose"
            :Position="Position"
            :onNoteSaved="onNoteSaved"
            :isShowStepper="isShowStepper"
            :onSetQuestion="onSetQuestion"
            :surplusTime="SurplusTime"
            :onGetAfterData="onGetAfterData"
            :id="id"
            :qaStatus="qaStatus"
            :isReadOnly="isReadOnly"
            :questionFontSize="questionFontSize"
            @save-question-rangy-mark="saveQuestionRangyMark"
          >
            <template #note="{ isShowNote }">
              <note
                :Question="Question"
                :onNoteSaved="onNoteSaved"
                :typeOfEditor="'EXERCISE_NOTE'"
                v-if="ms_isDebug && notable && isOpened && isShowNote"
              />
            </template>
          </Big>
          <!-- end of 大题 -->

          <!-- 答题卡 start  -->
          <Scantron
            :Position="Position"
            :QuestionList="QuestionList"
            :isTakingExam="isTakingExam"
            :Question="Question"
            :onSelect="selectQuestion"
          />
          <!-- 答题卡 end  -->
          <!-- 问答 start -->
          <qa
            :Question="Question"
            :id="id"
            @qa-opened="handleQaOpened"
            :typeOfEditor="'EXERCISE_QA'"
            v-if="
              qable &&
              isOpened &&
              (Question.qType !== 'xl' || Question.isInSubQuestions)
            "
          />
          <!-- 问答 end -->

          <QuestionReport
            :p_questionId="c_QuestionId"
            @question-reported="setQuestionReported"
          />

          <div class="_p802xx">
            <canvas
              :id="`question-canvas-${id}`"
              height="1000"
              width="1000"
              style="width: 500px; height: 500px"
            ></canvas>
          </div>
        </div>
        <PzFilter
          v-if="exerciseType === 8"
          :PzFilterData="PzFilterData"
          :onGetQuestions="onGetQuestions"
          :onClosePzFilter="closePzFilter"
        />
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { findIndex } from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import confetti from 'canvas-confetti';
import Swal from 'sweetalert2';

import Loading from './Loading.vue';
import FirstFilter from './FirstFilter.vue';
import CollectionWronglistFilter from './CollectionWronglistFilter.vue';
import PzFilter from './PzFilter.vue';
import NoData from './NoData.vue';
import Before from './Before.vue';
import After from './After.vue';
import Scantron from './Scantron.vue';
import QuestionReport from './QuestionReport.vue';
import Small from './Small.vue';
import Big from './Big.vue';
import { playSound } from '../../utils';

import { QuestionNoteQaContainerMixin } from '@/mixins/NoteQA/container/QuestionNoteQaContainer';

export default {
  name: 'Question',

  mixins: [QuestionNoteQaContainerMixin],

  components: {
    FirstFilter,
    CollectionWronglistFilter,
    PzFilter,
    NoData,
    Before,
    After,
    Scantron,
    QuestionReport,
    Loading,
    Small,
    Big,
  },

  props: {
    onRemoveWrongList: {
      type: Function,
      default: () => {},
    },

    id: {
      type: String,
      default: () => 'pz-question',
    },

    onRetry: {
      type: Function,
      default: () => {},
    },

    exerciseType: {
      type: Number,
      default: () => -1,
    },

    qable: {
      type: Boolean,
      default: () => false,
    },

    notable: {
      type: Boolean,
      default: () => false,
    },

    markable: {
      type: Boolean,
      default: () => false,
    },

    onMark: {
      type: Function,
      default: () => {},
    },

    visiable: {
      type: Boolean,
      default: () => false,
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    QuestionList: {
      type: Array,
      default: () => [],
    },

    Question: Object,

    title: {
      type: String,
      default: () => '',
    },

    FirstFilterList: {
      type: Array,
      default: () => [],
    },

    typeQuestionList4mycollection: {
      type: Array,
      default: () => [],
    },

    mywrongCountList: {
      type: Array,
      default: () => [],
    },

    isShowFilter: {
      type: Boolean,
      default: () => true,
    },

    isShowScantron: {
      type: Boolean,
      default: () => false,
    },

    isShowStepper: {
      type: Boolean,
      default: () => false,
    },

    onAnswer: {
      type: Function,
      default: () => {},
    },

    onGoTo: {
      type: Function,
      default: () => {},
    },

    onGetQuestions: {
      type: Function,
      default: () => {},
    },

    // tips: {
    //   type: String,
    //   default: () => '',
    // },

    PzFilterData: {
      type: Object,
      default: () => {},
    },

    hasBefore: {
      type: Boolean,
      default: () => false,
    },

    BeforeData: {
      type: Object,
      default: () => {},
    },

    hasAfter: {
      type: Boolean,
      default: () => false,
    },

    AfterData: {
      type: Object,
      default: function () {
        return {};
      },
    },

    onGetAfterData: {
      type: Function,
      default: () => {},
    },

    onTS: {
      type: Function,
      default: () => {},
    },

    onSetQuestion: {
      type: Function,
      default: () => {},
    },

    isTakingExam: {
      type: Boolean,
      default: () => false,
    },

    onBackToPaper: {
      type: Function,
      default: () => {},
    },

    onNoteSaved: {
      type: Function,
      default: () => {},
    },

    isReadOnly: {
      type: Boolean,
      default: () => false,
    },

    isInReview: {
      type: String,
      default: () => '',
    },

    setIsInReview: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      isStarted: false,
      SurplusTime: '0',
      countingDown: null,
      //noteContent: '',
      qaStatus: true,
      isFullscreen: false,
      isFilterPanelOpen: false,
      isShowFirstFilterPanel: false,
      isShowFirstFilterPanelContent: false,
      isShowQuestionPanel: false,
      isQuestionReported: false,

      promiseOnClose: null,
      isOpened: false,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      loading: 'loading',
      immLoading: 'immLoading',
      aopLoading: 'aopLoading',
      userInfo: 'userInfo',
    }),

    questionFontSize: {
      get: function () {
        return this.userInfo.profile.questionFontSize;
      },
    },

    questionLanguage() {
      return this.userInfo.profile.questionLanguage;
    },

    turnOnVoice: {
      get: function () {
        return this.userInfo.profile.turnOnVoice;
      },
      set: function (turnOnVoice) {
        this.updateProfile({ turnOnVoice });
      },
    },

    Position: function () {
      if (this.QuestionList.length) {
        return (
          findIndex(this.QuestionList, {
            questionId: this.Question.questionId,
          }) + 1
        );
      }
      return 0;
    },

    showSpinnerPanel: function () {
      return (
        this.loading ||
        (!this.showNoDataPanel &&
          (!this.showFirstFilterPanel || !this.isShowFirstFilterPanelContent) &&
          !this.showQuestionPanel &&
          !this.showBeforePanel &&
          !this.showAfterPanel)
      );
    },

    showNoDataPanel: function () {
      return (
        !this.FirstFilterList.length &&
        isEmpty(this.Question) &&
        !this.immLoading &&
        isEmpty(this.BeforeData) &&
        isEmpty(this.AfterData)
      );
    },

    showFirstFilterPanel: function () {
      return (
        this.isShowFirstFilterPanel ||
        (isEmpty(this.Question) &&
          !this.loading &&
          this.FirstFilterList.length > 0)
      );
    },

    showCollectionWronglistFilterPanel: function () {
      //return false;
      return (
        this.showFirstFilterPanel &&
        (2 === this.exerciseType || 3 === this.exerciseType)
      );
    },

    showQuestionPanel: function () {
      return (
        'question' === this.isInReview ||
        (!this.isInReview &&
          !isEmpty(this.Question) /*&& !this.loading*/ &&
          isEmpty(this.AfterData))
      );
    },

    showBeforePanel: function () {
      return (
        'before' === this.isInReview ||
        (!this.isInReview &&
          isEmpty(this.Question) &&
          !isEmpty(this.BeforeData) &&
          !this.loading)
      );
    },

    showAfterPanel: function () {
      return (
        'after' === this.isInReview ||
        (!this.isInReview && !isEmpty(this.AfterData) && !this.loading)
      );
    },
  },

  watch: {
    visiable: async function (v) {
      if (v) {
        await this.promiseOnClose;
        $(`#${this.id}`).modal({ backdrop: 'static', keyboard: false });
      }
    },

    Question: function (v1, v2) {
      if (v1 && v2 && v1.questionId !== v2.questionId) {
        this.isQuestionReported = false;
      }
    },

    showFirstFilterPanel: function (v1 /* , v2 */) {
      if (v1) {
        this.isShowFirstFilterPanel = true;
        this.isShowFirstFilterPanelContent = true;
      }
    },

    showQuestionPanel: function (v1 /* , v2 */) {
      if (v1) {
        this.isShowQuestionPanel = true;
      }
    },
  },

  mounted() {
    $(`#${this.id}`)
      .on('hidden.bs.modal', (e) => {
        this.setIsInReview({ stepInReview: '' });
        if (
          (e.target &&
            e.target.className &&
            e.target.className == 'question_answer') ||
          e.target.className.indexOf('pz-filter') != -1
        ) {
          return;
        }
        this.isStarted = false;
        this.isShowFirstFilterPanel = false;
        this.isShowFirstFilterPanelContent = false;
        this.isShowQuestionPanel = false;
        this.isFullscreen = false;
        clearInterval(this.countingDown);
        this.isOpened = false;
        this.promiseOnClose = this.onClose();
      })
      .on('show.bs.modal', () => {
        this.isOpened = true;
      });
  },

  beforeDestroy() {
    this.close();
  },

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    setQuestionFontSize(size) {
      this.updateProfile({ questionFontSize: size });
    },

    async setQuestionLanguage(questionLanguage) {
      await this.updateProfile({
        questionLanguage,
      });
      this.$emit('update-question-html');
    },

    resizeModal() {
      this.isFullscreen = !this.isFullscreen;
    },

    close() {
      $(`#${this.id}`).modal('hide');
      clearInterval(this.countingDown);
    },

    checkWhenClose(flag) {
      const _this = this;
      if (_this.isInReview) {
        _this.setIsInReview({ stepInReview: 'after' });
        return;
      } else if (flag) {
        _this.onGetAfterData();
      } else if (!_this.isStarted || !_this.hasAfter || _this.isTakingExam) {
        Swal.fire({
          title: '确定关闭？',
          icon: 'warning',
          showCancelButton: true,
          // confirmButtonColor: '#3085d6',
          // cancelButtonColor: '#d33',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async (result) => {
          if (result.value) {
            $(`#${_this.id}`).modal('hide');
          }
        });
      } else {
        if (_this.exerciseType == 12) {
          Swal.fire({
            title: '确定提交本次挑战吗？',
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            // confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '保存本次挑战，稍后继续',
            cancelButtonText: '提交本次挑战，查看结果',
          }).then(async (result) => {
            if (result.value) {
              await _this.onTS();
              Swal.fire({
                width: '400px',
                backdrop: false,
                icon: 'success',
                title: `挑战保存成功`,
                showConfirmButton: false,
                timer: 1500,
              });
              $(`#${_this.id}`).modal('hide');
            } else if (result.dismiss === 'cancel') {
              Swal.close();
              _this.onGetAfterData();
            }
          });
        } else {
          Swal.fire({
            title: '确定关闭？',
            icon: 'warning',
            showCancelButton: true,
            // confirmButtonColor: '#3085d6',
            // cancelButtonColor: '#d33',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(async (result) => {
            if (result.value) {
              _this.onGetAfterData();
            }
          });
        }
      }
    },

    async answer(payload) {
      this.isStarted = true;
      if (
        ((this.Question.answer == this.Question.selectedOption &&
          this.Question.qType !== 'xl') ||
          (this.Question.qType === 'xl' &&
            this.Question.subQuestions[this.Question.pos].answer ==
              this.Question.subQuestions[this.Question.pos].selectedOption)) &&
        !this.isTakingExam
      ) {
        const canvas = document.getElementById(`question-canvas-${this.id}`);
        canvas.confetti =
          canvas.confetti ||
          confetti.create(canvas, {
            resize: true,
          });

        canvas.confetti({
          particleCount: 100,
          spread: 70,
          startVelocity: 20,
          angle: 120,
          origin: {
            y: 1,
            x: 1,
          },
        });
        if (this.turnOnVoice) {
          const mySound = new playSound(
            'http://class.pzacademy.com/mp3/question-correct.mp3'
          );
          mySound.play();
        }
      } else if (
        this.Question.questionType.indexOf('QA') === -1 &&
        !this.isTakingExam
      ) {
        if (this.turnOnVoice) {
          const mySound = new playSound(
            'http://class.pzacademy.com/mp3/wrong.mp3'
          );
          mySound.play();
        }
      }
      await this.onAnswer(payload);
    },

    goToNext() {
      const index = findIndex(this.QuestionList, {
        questionId: this.Question.questionId,
      });
      const nextQuestion = this.QuestionList[index + 1];
      if (nextQuestion) {
        this.onGoTo(nextQuestion.questionId);
      }
    },

    goToPrev() {
      const index = findIndex(this.QuestionList, {
        questionId: this.Question.questionId,
      });
      const prevQuestion = this.QuestionList[index - 1];
      if (prevQuestion) {
        this.onGoTo(prevQuestion.questionId);
      }
    },

    selectQuestion(questionId) {
      this.onGoTo(questionId);
    },

    goToSubQ() {
      this.Question.inSubQ = true;
    },
    backToQ() {
      this.Question.inSubQ = false;
    },

    getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        total: t,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },

    startCountingDown() {
      const _this = this;
      const endTime = new Date(
        Date.parse(new Date()) + this.BeforeData.surplusTime
      );
      this.countingDown = setInterval(() => {
        let t = _this.getTimeRemaining(endTime);
        _this.SurplusTime =
          ('0' + t.hours).slice(-2) +
          ':' +
          ('0' + t.minutes).slice(-2) +
          ':' +
          ('0' + t.seconds).slice(-2);
        if (t.total <= 0) {
          clearInterval(this.countingDown);
          _this.onGetAfterData({ auto: true });
        }
      }, 1000);
    },

    openFilter() {
      if (this.exerciseType == 8) {
        this.openPzFilter();
      } else if (this.exerciseType == 2 || this.exerciseType == 3) {
        this.setIsShowFirstFilterPanelContent(true);
      }
    },

    openPzFilter() {
      $('#pzFilter').modal({ backdrop: false, show: true });
      this.isFilterPanelOpen = true;
    },

    closePzFilter() {
      this.isFilterPanelOpen = false;
    },

    setIsShowFirstFilterPanelContent(status) {
      this.isShowFirstFilterPanelContent = status;
    },

    setIsShowFirstFilterPanelAndContent(status) {
      this.isShowFirstFilterPanel = status;
      this.isShowFirstFilterPanelContent = status;
    },

    handleQaOpened(isQaOpened) {
      this.qaStatus = !isQaOpened;
    },

    setQuestionReported() {
      this.isQuestionReported = true;
    },

    saveQuestionRangyMark(payload) {
      this.$emit('save-question-rangy-mark', {
        ...payload,
        questionLanguage: this.questionLanguage,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
._p802xx {
  right: 0px !important;
  bottom: 0px !important;
  position: absolute !important;
  z-index: 200000 !important;
  pointer-events: none !important;
  -webkit-filter: Alpha(opacity=0) !important;
  filter: Alpha(opacity=0) !important;
}

.ck-content {
  height: 300px !important;
}
</style>
